import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
const RECURRING = [
    'weekly',
    'biweekly',
    'monthly',
    'quarterly',
    'yearly'
];
const ONE_TIME_BILLED_UPON = [
    'oneTimeManual',
    'oneTimeDelivery',
    'oneTimeInStages',
    'approval'
];
const ON_DEMAND_BILLED_UPON = 'onDemand';
const billedUponValues = (predicate)=>{
    var _ref, _predicate_in;
    return (_ref = (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : predicate.nin) !== null && _ref !== void 0 ? _ref : [];
};
const hasWholeOneTimeBucket = (values)=>ONE_TIME_BILLED_UPON.every((value)=>values.has(value));
const billedUponIsOccurrenceShaped = (predicate)=>{
    const values = billedUponValues(predicate);
    const set = new Set(values);
    const isOneTime = values.length === ONE_TIME_BILLED_UPON.length && hasWholeOneTimeBucket(set);
    const isOnDemand = values.length === 1 && set.has(ON_DEMAND_BILLED_UPON);
    const isBoth = values.length === ONE_TIME_BILLED_UPON.length + 1 && hasWholeOneTimeBucket(set) && set.has(ON_DEMAND_BILLED_UPON);
    return isOneTime || isOnDemand || isBoth;
};
export const billedUponIsTriggerShaped = (predicate)=>!billedUponIsOccurrenceShaped(predicate);
export const occurrenceToSet = (service)=>{
    var _ref, _ref1;
    const recurrence = service.recurrence;
    const billedUpon = service.billedUpon;
    const billedIsOccurrence = billedUpon != null && billedUponIsOccurrenceShaped(billedUpon);
    const exclude = recurrence != null ? recurrence.nin != null : billedIsOccurrence && billedUpon.nin != null;
    const values = [
        ...(_ref = (_ref1 = recurrence === null || recurrence === void 0 ? void 0 : recurrence.in) !== null && _ref1 !== void 0 ? _ref1 : recurrence === null || recurrence === void 0 ? void 0 : recurrence.nin) !== null && _ref !== void 0 ? _ref : []
    ];
    if (billedIsOccurrence) {
        var _ref2, _billedUpon_in;
        const set = new Set((_ref2 = (_billedUpon_in = billedUpon.in) !== null && _billedUpon_in !== void 0 ? _billedUpon_in : billedUpon.nin) !== null && _ref2 !== void 0 ? _ref2 : []);
        if (ONE_TIME_BILLED_UPON.some((value)=>set.has(value))) values.push('oneTime');
        if (set.has(ON_DEMAND_BILLED_UPON)) values.push('onDemand');
    }
    return exclude ? {
        nin: values
    } : {
        in: values
    };
};
export const setToOccurrenceFields = (set)=>{
    var _ref;
    const exclude = set.nin != null;
    const values = (_ref = exclude ? set.nin : set.in) !== null && _ref !== void 0 ? _ref : [];
    const key = exclude ? 'nin' : 'in';
    const recurrence = values.filter((value)=>RECURRING.includes(value));
    const billedUpon = [];
    if (values.includes('oneTime')) billedUpon.push(...ONE_TIME_BILLED_UPON);
    if (values.includes('onDemand')) billedUpon.push(ON_DEMAND_BILLED_UPON);
    return _object_spread({}, recurrence.length > 0 && {
        recurrence: {
            [key]: recurrence
        }
    }, billedUpon.length > 0 && {
        billedUpon: {
            [key]: billedUpon
        }
    });
};
